import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { SharedService } from '../../services/shared.service';
import { Subscription } from 'rxjs';
import { AlertService } from '../alert/alert.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dropdown-checkbox-project',
  templateUrl: './dropdown-checkbox-project.component.html',
  styleUrls: ['./dropdown-checkbox-project.component.scss']
})
export class DropdownCheckboxProjectComponent {

  @Input() dropDownOption: any | null = [];
  @Input() json_data: boolean = false;
  @Input() showInvalueText: boolean = true;
  @Input() selected_item: any[] = [];
  @Input() search = false;
  @Input() dropdownTitle: string = '';
  @Output() dropDownValue: EventEmitter<any> = new EventEmitter();

  languageSub$: Subscription = new Subscription();
  langName = 'en';
  selectedItem: any = [];
  filteredOptions: any = [];
  selectedOptions: any = [];

  constructor(private shareService: SharedService, private alert: AlertService,private translate: TranslateService) {
    this.languageSub$ = this.shareService.language$.subscribe(lang => {
      this.langName = lang;
      this.selectedVal(this.selected_item);
    })
  }


  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selected_item']) {
      if(!this.filteredOptions.length){
        this.filteredOptions = this.dropDownOption || [];
      }
      this.selectedItem = this.selected_item;
      this.selectedVal(this.selected_item);
    }
  }

  selectedVal(selected_item?: any) {
    this.selectedOptions = selected_item.map((e:string)=>
      this.filteredOptions.find((f:any) => f.name == e)?.label
    );
  }

  toggleResidentialType(event: any, key: string) {

    if (event.checked) {
      if (!this.selectedItem.includes(key)) {
        this.selectedItem = [...this.selectedItem, key];
      }
    } else {
      if (this.selectedItem.length === 1) {
        event.source.checked = true; // revert checkbox visually
        return;
      }
      this.selectedItem = this.selectedItem.filter((e: any) => e !== key);
    }

  }



  onMenuClosed() {
    if (!this.selectedItem.length) {
       const msg = this.translate.instant('reports.please_select_at_least_one_option');
        this.alert.warn(msg);
      this.selectedItem = this.selected_item;
      this.selectedVal(this.selected_item);
      return;
    }
    if (!this.arraysHaveSameItems(this.selectedItem, this.selected_item)) {
      this.selectedVal(this.selectedItem);
      this.dropDownValue.emit(this.selectedItem?.toString());
    }
  }


  arraysHaveSameItems(arr1: string[], arr2: string[]): boolean {
    if (arr1.length !== arr2.length) return false;

    const sortedA = [...arr1].sort();
    const sortedB = [...arr2].sort();

    return sortedA.every((item, index) => item === sortedB[index]);
  }

  selectAll(event: any) {
    if (event.checked) {
      this.selectedItem = this.filteredOptions.map((opt: any) => opt.name);
    } else {
      this.selectedItem = [];
    }

  }

  isCheckedSelectAll() {
    return this.selectedItem.length === this.filteredOptions.length;
  }

   ngOnDestroy(): void{
    this.languageSub$.unsubscribe()
    }

}
